import { __decorate } from "tslib";
import { Vue, Component, Mixins } from "vue-property-decorator";
import { dataMapper } from "@/services/store/modules/data/store";
import IconSvg from "@/components/IconSvg.vue";
const UiMappers = Vue.extend({});
const DataMappers = Vue.extend({
    computed: {
        ...dataMapper.mapState(["phone"]),
    },
    methods: {},
});
let InfoReviews = class InfoReviews extends Mixins(UiMappers, DataMappers) {
};
InfoReviews = __decorate([
    Component({
        components: {
            IconSvg,
        },
    })
], InfoReviews);
export default InfoReviews;
